import { Badge } from '@monksflow/monks-ui';
import { i18n } from '@/shared/i18n';
import { microInteraction } from '@/shared/ui/MicroInteractions';
import type { TaxonomyStatus } from '../../model/types';

type BadgeVariant = 'default' | 'secondary' | 'warning' | 'positive' | 'destructive';

interface StatusBadgeInfo {
  label: string;
  variant: BadgeVariant;
}

// Getters, not values: resolving a label here would freeze it at import.
const DRAFT_BADGE: StatusBadgeInfo = {
  get label() {
    return i18n.t('knowledge:taxonomy.taxonomyStatusBadge.draft');
  },
  variant: 'default',
};

const STATUS_MAP: Record<TaxonomyStatus, StatusBadgeInfo> = {
  draft: DRAFT_BADGE,
  published: {
    get label() {
      return i18n.t('knowledge:taxonomy.taxonomyStatusBadge.published');
    },
    variant: 'positive',
  },
  archived: {
    get label() {
      return i18n.t('knowledge:taxonomy.taxonomyStatusBadge.archived');
    },
    variant: 'secondary',
  },
};

export interface TaxonomyStatusBadgeProps {
  status: TaxonomyStatus | null | undefined;
}

export function TaxonomyStatusBadge({ status }: TaxonomyStatusBadgeProps) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- STATUS_MAP is indexed, so a status outside the map reads as present
  const { label, variant } = (status && STATUS_MAP[status]) || DRAFT_BADGE;

  return (
    <Badge variant={variant} roundness="full" className={microInteraction.statusBadge}>
      {label}
    </Badge>
  );
}

TaxonomyStatusBadge.displayName = 'TaxonomyStatusBadge';
